import { useEffect, useState } from 'react'
import { ArrowRight } from 'lucide-react'
import { redirectToClipboardCheckout } from '../lib/clipboardCheckout'

export function SubscribeClipboard() {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    document.title = 'JOT Clipboard — Unlock full history'
  }, [])

  async function buy() {
    setError(null)
    setBusy(true)
    try {
      await redirectToClipboardCheckout()
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Checkout failed')
      setBusy(false)
    }
  }

  return (
    <div className="lp lp--extension">
      <nav className="lp-nav">
        <div className="lp-nav-inner">
          <a href="/home" className="lp-wordmark">JOT</a>
          <div className="lp-nav-center">
            <a href="/home" className="lp-nav-link">Clipboard</a>
            <a href="/subscribe" className="lp-nav-link">Unlock</a>
            <a href="/editor" className="lp-nav-link">Editor</a>
          </div>
        </div>
      </nav>

      <section className="lp-hero">
        <div className="lp-hero-inner clip-buy">
          <p className="lp-hero-eyebrow">JOT Clipboard</p>
          <h1 className="lp-hero-headline">Full history, $30 once.</h1>
          <p className="lp-hero-body">
            Capture stays free. Search the last 7 days free. Paying unlocks
            everything this device has kept — no subscription, no account.
            Clips never leave your machine. Checkout only proves you paid.
          </p>
          <div className="lp-hero-actions">
            <button type="button" className="lp-cta-primary" onClick={buy} disabled={busy}>
              {busy ? 'Redirecting…' : 'Unlock full history — $30'}
              <ArrowRight className="w-4 h-4" />
            </button>
            <span className="lp-hero-proof">One-time &nbsp;·&nbsp; Binds to this Chrome install</span>
          </div>
          {error && <p className="clip-buy-error">{error}</p>}
          <p className="clip-buy-restore">
            Already paid? <a href="/extension/restore">Restore on this computer</a>
          </p>
        </div>
      </section>
    </div>
  )
}
